import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["card", "toggle", "enterpriseBanner"]
  static values = { view: { type: String, default: "essential" } }

  connect() {
    this.show(this.viewValue)
  }

  switch(event) {
    const view = event.currentTarget.dataset.view
    this.viewValue = view
    this.show(view)
  }

  show(view) {
    // Update toggle buttons
    this.toggleTargets.forEach(btn => {
      const isActive = btn.dataset.view === view
      btn.style.background = isActive ? "var(--action-primary)" : "transparent"
      btn.style.color = isActive ? "var(--text-inverse)" : "var(--text-secondary)"
      btn.style.fontWeight = isActive ? "600" : "500"
    })

    // Show/hide cards
    this.cardTargets.forEach(card => {
      const group = card.dataset.pricingGroup
      card.style.display = (group === view || group === "both") ? "flex" : "none"
    })

    // Show/hide enterprise banner (only in essential view)
    if (this.hasEnterpriseBannerTarget) {
      this.enterpriseBannerTarget.style.display = view === "essential" ? "flex" : "none"
    }
  }
}
